import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface ResumeArgusInstanceInput {
  instanceId: string;
}

export function useResumeArgusInstance() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: ResumeArgusInstanceInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}/resume`, {
        method: "POST",
      });
    },
    onSettled: (_, __, variables) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/instances"),
      });
      queryClient.invalidateQueries({
        queryKey: [`/client/argus/instances/${variables.instanceId}`],
      });
    },
  });
}
